
import { createRoot, hydrateRoot } from 'react-dom/client'
import { HelmetProvider } from 'react-helmet-async';
import App from './App.tsx'
import './index.css'

const helmetContext = {};

const rootElement = document.getElementById("root")!;

// Check if the element has child nodes (for hydration with react-snap)
if (rootElement.hasChildNodes()) {
  hydrateRoot(
    rootElement,
    <HelmetProvider context={helmetContext}>
      <App />
    </HelmetProvider>
  );
} else {
  createRoot(rootElement).render(
    <HelmetProvider context={helmetContext}>
      <App />
    </HelmetProvider>
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
